import React, { useEffect, useState } from "react";
import "./style/CaseWin.css"
import "./style/BaseModal.css"
import "./style/CaseLine.css"

import StarMini from "../assets/image/Star.svg"
import SCoin from "../assets/image/S-coint.svg"

import { ReactComponent as WinBackground } from "../assets/image/bg/win.svg"
import { ReactComponent as StarBackground } from "../assets/image/case-item-background.svg"

import { Trans } from "react-i18next";

import CaseWinAudio from "../assets/sound/win.mp3"

const arrow = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.8005 4.09344C12.3369 3.70714 11.6636 3.70714 11.2 4.09343L5.73644 8.6464C5.51137 8.83396 5.644 9.20029 5.93698 9.20029C6.93841 9.20029 7.75023 10.0121 7.75023 11.0135V18.9503C7.75023 19.6406 8.30987 20.2003 9.00023 20.2003H15.0002C15.6906 20.2003 16.2502 19.6406 16.2502 18.9503V11.0135C16.2502 10.0121 17.062 9.20029 18.0635 9.20029C18.3565 9.20029 18.4891 8.83396 18.264 8.6464L12.8005 4.09344ZM10.2397 2.9411C11.2596 2.09125 12.7409 2.09125 13.7607 2.9411L19.2243 7.49407C20.5271 8.57977 19.7594 10.7003 18.0635 10.7003C17.8905 10.7003 17.7502 10.8405 17.7502 11.0135V18.9503C17.7502 20.4691 16.519 21.7003 15.0002 21.7003H9.00023C7.48145 21.7003 6.25023 20.4691 6.25023 18.9503V11.0135C6.25023 10.8405 6.10998 10.7003 5.93698 10.7003C4.24105 10.7003 3.47332 8.57977 4.77617 7.49406L10.2397 2.9411Z" fill="#FDFDFD"/>
</svg>

const moneyBag = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.50838 2.43343C7.73754 2.23467 8.06386 2.19353 8.33518 2.32918L9.99993 3.16148L11.6644 2.3292C11.8755 2.22361 12.1241 2.22361 12.3352 2.3292L13.9997 3.16148L15.6644 2.32918C15.9357 2.19353 16.262 2.23467 16.4912 2.43343C16.7204 2.63218 16.8072 2.94941 16.7113 3.23718L16.2666 4.57143C16.5946 4.44315 16.9389 4.32456 17.2855 4.22769C17.7997 4.08399 18.347 3.98006 18.8693 3.97504C19.3857 3.97009 19.9441 4.06141 20.416 4.37597C20.7606 4.60574 20.8538 5.07139 20.624 5.41604C20.3942 5.76068 19.9286 5.85381 19.5839 5.62405C19.4558 5.53861 19.235 5.4716 18.8837 5.47498C18.5383 5.47829 18.1293 5.54936 17.6893 5.67233C17.3462 5.76821 17.0013 5.89075 16.6759 6.02303C19.4527 7.83857 21.1146 11.434 20.9993 14.7759C20.9315 16.7431 20.2498 18.6856 18.7644 20.171C17.2761 21.6593 15.0519 22.618 12.0324 22.7493C12.0107 22.7502 11.9889 22.7502 11.9672 22.7493C8.94769 22.618 6.72348 21.6593 5.23514 20.171C3.74974 18.6856 3.06811 16.7431 3.00026 14.7759C2.87497 11.1434 4.84937 7.21136 8.07292 5.59111L7.28828 3.23718C7.19236 2.94941 7.27922 2.63218 7.50838 2.43343ZM8.96469 6.82744C6.23992 8.0624 4.38703 11.4674 4.49937 14.7242C4.55655 16.3819 5.12495 17.9395 6.2958 19.1103C7.45907 20.2736 9.28734 21.1252 11.9998 21.2493C14.7122 21.1252 16.5405 20.2736 17.7038 19.1103C18.8746 17.9395 19.443 16.3819 19.5002 14.7242C19.6131 11.4527 17.7429 8.03169 14.998 6.81087C12.3863 7.82702 10.1186 7.36305 8.96469 6.82744ZM14.3977 5.43462C12.2214 6.2618 10.4092 5.83898 9.6158 5.47631L9.28386 4.4805L9.66457 4.67084C9.87572 4.77641 10.1242 4.7764 10.3354 4.67082L11.9998 3.83855L13.6642 4.67082C13.8753 4.7764 14.1239 4.77641 14.335 4.67084L14.7157 4.4805L14.3977 5.43462Z" fill="#FDFDFD"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.9045 10.375C12.2497 10.375 12.5295 10.6548 12.5295 11V11.0066C13.7068 11.1287 14.6248 12.1238 14.6248 13.3333C14.6248 13.6785 14.345 13.9583 13.9998 13.9583C13.6546 13.9583 13.3748 13.6785 13.3748 13.3333C13.3748 12.8157 13.0136 12.3823 12.5295 12.2715V13.9943C13.6894 14.0102 14.6248 14.9554 14.6248 16.1191C14.6248 17.2827 13.6894 18.2279 12.5295 18.2439C12.5264 18.5864 12.2478 18.8631 11.9045 18.8631C11.5594 18.8631 11.2795 18.5833 11.2795 18.2381V18.2038C10.1952 18.0001 9.37478 17.0482 9.37478 15.9048C9.37478 15.5596 9.65461 15.2798 9.99978 15.2798C10.345 15.2798 10.6248 15.5596 10.6248 15.9048C10.6248 16.3519 10.8942 16.7361 11.2795 16.9039V15.2328C10.2094 15.1226 9.37478 14.2183 9.37478 13.1191C9.37478 12.0198 10.2094 11.1155 11.2795 11.0053V11C11.2795 10.6548 11.5594 10.375 11.9045 10.375ZM11.2795 12.272C10.9029 12.3697 10.6248 12.7119 10.6248 13.1191C10.6248 13.5262 10.9029 13.8685 11.2795 13.9661V12.272ZM12.5295 15.2446V16.9936C12.999 16.9779 13.3748 16.5923 13.3748 16.1191C13.3748 15.6458 12.999 15.2602 12.5295 15.2446Z" fill="#FDFDFD"/>
</svg>



const CaseWin = ({ cases, onComplete }) => {
  // cases = [{ value, case_color, jackpot }, ...]
  const audioRef = React.useRef(null);

  const [timer, setTimer] = useState(120); // начальный таймер 120 секунд

  useEffect(() => {
    if (localStorage.getItem("audio") === "1") {
      audioRef.current?.play().catch(() => {});
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          finishCase();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []); 

  const finishCase = () => {
      onComplete?.();
  };

  const totalValue = cases.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="case-win-wrapper">
      <div className="backdrop show"></div>
      <audio ref={audioRef} src={CaseWinAudio} preload="auto" />
      <div className="win-bg-wrapper">
        <WinBackground className="win-background" style={{ color: cases[0].case_color }} />
      </div>
      <div className="case-win-items">
        <h1><Trans i18nKey="win.header" /></h1>

        {cases.length > 1 ? (
          <div className="mini-item-win-wrapper">
            {cases.map((item, index) => {
              const color = item.jackpot ? "rgba(239, 168, 14, 1)" : item.case_color;
              const imgSize = item.jackpot ? { width: 104, height: 64 } : { width: 66, height: 64 };
              
              return (
                <div className="case-win-item-mini" key={index}>
                  <div className="mini-item-win"
                    style={{
                      "--glow-color": color,
                      "--glow-color-soft": `color-mix(in srgb, ${color} 30%, transparent)`,
                    }}
                  >
                    <img src={StarMini} alt="star" className="mini-item-win-img" width={imgSize.width} height={imgSize.height}/>
                    <span className="white-text">{item.value}</span>
                    <div className="mini-item-win-down" style={{background: color}}></div>
                  </div>
                  <div style={{display: "flex", width: "100%", flexDirection: "row", gap: 8}}>
                    <button className="default-blue-button mini-button">{moneyBag}</button>
                    <button className="empty-button blur mini-button">{arrow}</button>
                  </div>
                </div>
              );
            })}
          </div>
          ) : (() => {
            const { value, case_color, jackpot } = cases[0];
            const imgSize = jackpot ? { width: 104, height: 64 } : { width: 66, height: 64 };
            const color = jackpot ? "rgba(239, 168, 14, 1)" : case_color;

            return (
              <div className="case-item">
                <div className="background-layer" style={{ color }}>
                  <StarBackground />
                </div>
                <img src={StarMini} alt="" width={imgSize.width} height={imgSize.height} />
                <span>{value}</span>
                <div className="down" style={{ background: color }}></div>
              </div>
            );
          })()
        }

        <div style={{display: "flex", flexDirection: "column", gap: "12px", width: "93%"}}>
          <button className="default-blue-button" onClick={finishCase}>
            {moneyBag} <Trans i18nKey="win.sell-button" /> <img style={{width: "20px", height: "20px"}} src={SCoin} /> {totalValue}
          </button>
          <button className="empty-button blur" onClick={finishCase} style={{color: "rgba(255, 255, 255, 1)"}}>
            {arrow} <Trans i18nKey="win.withdraw-button" /> <img style={{width: "20px", height: "20px"}} src={StarMini} /> {totalValue}
          </button>
          <span className="win-text text-center"><Trans i18nKey="win.need-sell-text" values={{second: timer}} /></span>
        </div>
      </div>
    </div>
  );
};

export default CaseWin;
